module.exports = __webpack_public_path__ + "img/blue_bay_courts.6354dc6b.jpeg";